import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 26, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.65, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const RevealStagger = ({ children, className }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-70px" }}
    variants={{ show: { transition: { staggerChildren: 0.09 } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className, y = 24 }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } } }}
  >
    {children}
  </motion.div>
);
